import { useMemo } from "react";

import { useBranding } from "./BrandingContext";

export const useIsPWCBranding = (): boolean => {
  const { activeBranding } = useBranding();
  return useMemo(() => activeBranding === "pwc", [activeBranding]);
};

export const useIsMSquaredBranding = (): boolean => {
  const { activeBranding } = useBranding();
  return useMemo(() => activeBranding === "msquared", [activeBranding]);
};

export const useIsICRABranding = (): boolean => {
  const { activeBranding } = useBranding();
  return useMemo(() => activeBranding === "icra", [activeBranding]);
};

export const useIsICRAResearchAssistBranding = (): boolean => {
  const { activeBranding } = useBranding();
  return useMemo(
    () => activeBranding === "icra-researchassist",
    [activeBranding],
  );
};

export const useIsArmadaBranding = (): boolean => {
  const { activeBranding } = useBranding();
  return useMemo(() => activeBranding === "armada", [activeBranding]);
};

/** A demo overlay is treated as a non-Needl brand so the existing force-light-mode
    rule applies and the demo behaves like a real customer brand. */
export const useIsNeedlBranding = (): boolean => {
  const { activeBranding, appBrand } = useBranding();
  return useMemo(
    () => !appBrand && activeBranding === "needl",
    [activeBranding, appBrand],
  );
};

export const useIsSoftwareOneBranding = (): boolean => {
  const { activeBranding } = useBranding();
  return useMemo(() => activeBranding === "softwareone", [activeBranding]);
};
